import {
  getRouteBadgeSvgStyle,
  getRouteBadgeType,
  normalizeRouteBadgeColor,
} from "@/lib/transitDisplay";

export const routeBadgeViewBox = {
  width: 100,
  height: 100,
};

export const routeBadgeShape = {
  type: "circle",
  centerX: 50,
  centerY: 50,
  radius: 50,
};

function escapeSvgText(value) {
  return String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

export function formatRouteLabel(label) {
  return String(label || "");
}

export function getWellingtonRouteBadgeRenderSpec({
  imageId,
  routeColor,
  routeLabel,
  routeType,
  route_short_name,
  service_id,
}) {
  const label = formatRouteLabel(routeLabel ?? route_short_name ?? service_id);
  const normalizedRouteColor = normalizeRouteBadgeColor(routeColor) || "#222B2D";
  const type = getRouteBadgeType(routeType, label);
  const { fillColor, strokeColor, textColor } = getRouteBadgeSvgStyle(
    type,
    normalizedRouteColor,
  );
  const letterSpacing = type === "night" ? "-0.05em" : "0";
  const isNumericLabel = label.trim() !== "" && !Number.isNaN(Number(label));
  const isFilledBadge = strokeColor == null;
  const usesNamedModeSmallText =
    isFilledBadge && type !== "night" && !isNumericLabel && label.length > 2;
  const usesSmallText =
    usesNamedModeSmallText ||
    (type === "night" ? label.length > 2 : label.length > 3);
  const usesMediumText =
    !usesNamedModeSmallText &&
    (type === "night" ? !usesSmallText : !usesSmallText && label.length > 2);
  const fontSize = usesSmallText ? 39 : usesMediumText ? 44 : 50;
  const textY = usesSmallText ? "64px" : usesMediumText ? "65px" : "67px";
  const textX = type === "night" ? "40%" : "50%";
  const fontWidth = 100;
  const maskId = `route-badge-night-${String(imageId || label).replace(/[^a-zA-Z0-9_-]/g, "-")}`;

  return {
    label,
    type,
    fillColor,
    strokeColor,
    textColor,
    letterSpacing,
    fontSize,
    textY,
    textX,
    fontWeight: 600,
    fontWidth,
    maskId,
  };
}

export function createRouteBadgeSvg(route, { renderText } = {}) {
  const {
    label,
    type,
    fillColor,
    strokeColor,
    textColor,
    letterSpacing,
    fontSize,
    textY,
    textX,
    fontWeight,
    fontWidth,
    maskId,
  } = getWellingtonRouteBadgeRenderSpec(route);
  const textElement = renderText
    ? renderText({
        label,
        fill: textColor,
        x: textX,
        y: textY,
        fontSize,
        fontWeight,
        fontWidth,
        letterSpacing,
      })
    : `<text fill="${textColor}" x="${textX}" y="${textY}" text-anchor="middle" font-size="${fontSize}" font-weight="${fontWeight}" font-stretch="${fontWidth}%" letter-spacing="${letterSpacing}" font-family="Bus, sans-serif" style="font-stretch: ${fontWidth}%; font-variation-settings: &quot;wdth&quot; ${fontWidth}, &quot;wght&quot; ${fontWeight};">${escapeSvgText(label)}</text>`;

  return `<svg viewBox="0 0 ${routeBadgeViewBox.width} ${routeBadgeViewBox.height}" width="128" height="128" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="${routeBadgeShape.centerX}" cy="${routeBadgeShape.centerY}" r="${strokeColor ? 48 : routeBadgeShape.radius}" fill="${fillColor}"${strokeColor ? ` stroke="${strokeColor}" stroke-width="4"` : ""}/>
  ${
    type === "night"
      ? `<defs><mask id="${maskId}"><circle cx="32" cy="${routeBadgeShape.centerY}" r="${routeBadgeShape.radius}" fill="white"/></mask></defs><circle cx="${routeBadgeShape.centerX}" cy="${routeBadgeShape.centerY}" r="${routeBadgeShape.radius}" fill="#101827DD" mask="url(#${maskId})"/>`
      : ""
  }
  ${textElement}
</svg>`;
}
